const METER_TO_MILES = 0.000621371192

export default {
  data () {
    return {
      myGeoLocationResult: {},
      showEnableLocationNotice: false,
    }
  },
  watch: {
  },
  filters: {
    capitalize (str) {
      return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})
    },
    pluralize (count) {
      return (count > 1) ? 's' : ''
    },
    slugify (str) {
      return utils.slugify(str)
    },
    secondsToMinutes (secs = 0) {
      return Math.round(secs / 60)
    },
    metersToMiles (meters = 0) {
      return (meters * METER_TO_MILES).toFixed(1)
    },
    formatDateTime (dt) {
      return moment(dt).format("MMM D") + ' at ' + moment(dt).format("hh:mm a")
    },    
    formatDate (dt) {
      return moment(dt).format("MMM D")
    },
    formatTime (dt) {
      return moment(dt).format("hh:mma")
    }    
  },
  computed: {
    myGeoLocationValid () {
      if (this.myGeoLocationResult === undefined) {
        return false
      }
      if (!this.myGeoLocationResult.hasOwnProperty('position')) {
        return false
      }
      return true
    },
    isMobile () {
      let w = window,
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          width = w.innerWidth || e.clientWidth || g.clientWidth,
          height = w.innerHeight|| e.clientHeight|| g.clientHeight;
      return (width < 750)
    },
    isIE () {
      return ((Object.hasOwnProperty.call(window, 'ActiveXObject') && !window.ActiveXObject) || navigator.userAgent.indexOf('MSIE') > -1)
    },
    METER_TO_MILES () {
      return METER_TO_MILES
    }
  },
  methods: {
    capitalize (sentence) {
      if (!sentence) {
        return sentence;
      }
      return sentence.split(" ").map(x => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()).join(" ")
    },    
    // Leaflet function?
    findTotalDistanceFromLatLngs (latLngs = []) {
      return latLngs.reduce((sum, elem, index, arr) => {
        if ((index + 1) >= arr.length) {
          return sum
        }
        let elem1 = arr[index]
        let elem2 = arr[index+1]
        let latLng1 = L.latLng(elem1[0], elem1[1])
        let latLng2 = L.latLng(elem2[0], elem2[1])
        return sum + latLng1.distanceTo(latLng2) // returns meters
      }, 0)
    },    
    // https://www.geodatasource.com/developers/javascript
    // or can use Google Maps Geometry function:
    // google.maps.geometry.spherical.computeDistanceBetween(gll1, gll2)
    calcDistBetweenLatLngs (lat1, lon1, lat2, lon2, unit) {
      var radlat1 = Math.PI * lat1/180
      var radlat2 = Math.PI * lat2/180
      var theta = lon1-lon2
      var radtheta = Math.PI * theta/180
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist)
      dist = dist * 180/Math.PI
      dist = dist * 60 * 1.1515
      if (unit=="K") { dist = dist * 1.609344 }
      if (unit=="N") { dist = dist * 0.8684 }
      return dist
    }   
    // 1 degree of Longitude = cosine (latitude in decimal degrees) * length of degree (miles) at equator.
    // Convert your latitude into decimal degrees ~ 37.26383
    // Convert your decimal degrees into radians ~ (37.26383/180) * PI = 0.79863
    // 1 degree of Longitude = ~0.79863 * 69.172 = ~ 55.2428 miles
    // https://gis.stackexchange.com/questions/142326/calculating-longitude-length-in-miles       
  },

  mounted () {

  },

}



// WEBPACK FOOTER //
// ./src/mixins/common.js